import BaseEntity from '../../base/BaseEntity.model';

export default class SolicitudRc extends BaseEntity {
    public tramiteBeneficiarioId?: number;
    public institucionRcId?: number;
    public infraestructuraRcId?: number;
    public servicioRcId?: number;
    public actividadRcId?: number;
    public nombreInstitucion?: string;
    public comentario?: number;
    public situacionesSeleccionadas?: string;
    constructor() {
        super();
        this.tramiteBeneficiarioId = undefined;
        this.institucionRcId = undefined;
        this.infraestructuraRcId = undefined;
        this.actividadRcId = undefined;
        this.nombreInstitucion = undefined;
        this.comentario = undefined;
        this.situacionesSeleccionadas = undefined;
    }
}